import React, { useState, useEffect } from 'react';
import { Menu, X, Shield, ExternalLink } from 'lucide-react';
import { personalInfo } from '../data/mock';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Experience', href: '#experience' },
  { label: 'Skills', href: '#skills' },
  { label: 'Certifications', href: '#certifications' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Insights', href: '#blog' },
  { label: 'Contact', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#06080d]/90 backdrop-blur-xl border-b border-[#1e293b]/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="flex items-center gap-2 group"
        >
          <div className="w-8 h-8 rounded-md bg-[#00e5ff]/10 border border-[#00e5ff]/30 flex items-center justify-center group-hover:bg-[#00e5ff]/20 transition-colors duration-300">
            <Shield className="w-4 h-4 text-[#00e5ff]" />
          </div>
          <span className="font-['JetBrains_Mono'] text-sm font-semibold text-[#f1f5f9] tracking-wide">
            {personalInfo.name.split(' ')[0].toLowerCase()}
            <span className="text-[#00e5ff]">.sec</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="px-3 py-2 text-sm text-[#94a3b8] hover:text-[#00e5ff] transition-colors duration-200 font-medium"
            >
              {link.label}
            </a>
          ))}
          <a
            href={personalInfo.socialLinks.saraswatiRepo}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-3 flex items-center gap-1.5 px-4 py-2 text-xs font-['JetBrains_Mono'] font-medium bg-[#00e5ff]/10 text-[#00e5ff] border border-[#00e5ff]/30 rounded-md hover:bg-[#00e5ff]/20 transition-colors duration-300"
          >
            Blog <ExternalLink className="w-3 h-3" />
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 text-[#94a3b8] hover:text-[#00e5ff] transition-colors duration-200"
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileOpen && (
        <div className="md:hidden bg-[#0c1017]/98 backdrop-blur-xl border-b border-[#1e293b]/60">
          <nav className="flex flex-col px-6 py-4 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="px-3 py-3 text-sm text-[#94a3b8] hover:text-[#00e5ff] transition-colors duration-200 border-b border-[#1e293b]/30 last:border-0"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
